// @flow
import type { Node } from 'react';

type Props = {
  isShow: boolean,
  children: Function,
};

export default function SourceLoaderSwitch({ isShow, children }: Props): Node {
  if (typeof children !== 'function') {
    return null;
  }

  return children(isShow);
}



// WEBPACK FOOTER //
// ./app/Sources/loader/components/SourceLoaderSwitch/index.js